import type { LessonType } from "@prisma/client";

/**
 * The skill spokes, in radar clockwise order. This tuple is the single place
 * the set is written down - the Modality union is derived from it, so the two
 * cannot disagree.
 */
export const MODALITIES = ["READING", "WRITING", "SPEAKING", "LISTENING"] as const;

/** Skill spoke on the radar / lesson board. LISTENING is practiced via DICTATION lessons. */
export type Modality = (typeof MODALITIES)[number];

export function modalityToLessonType(modality: Modality): LessonType {
  return modality === "LISTENING" ? "DICTATION" : modality;
}

export function lessonTypeToModality(lessonType: LessonType): Modality {
  return lessonType === "DICTATION" ? "LISTENING" : lessonType;
}
